import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import {
  leftAlignedCell,
  tableWrapper,
} from "../../../styles/sharedTableStyles.css";

export const sheetWrapper = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: vars.space.m,
  paddingTop: 0,
  height: "100%",
});

export const containerStyles = style({
  borderRadius: vars.radii.l,
  backgroundColor: vars.colors.surface,
});

export const costTableWrapper = style([tableWrapper, { maxHeight: 350 }]);

export const tableTitle = style({
  padding: vars.space.m,
  paddingBottom: 0,
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.heading.m,
});

export const contentWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  height: "100%",
});

export const actionButtonsWrapper = style({
  display: "flex",
  gap: vars.space.xs,
});

export const costCell = style([
  leftAlignedCell,
  {
    width: "10%",
  },
]);
